(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("krtMarketingTrackingService", krtMarketingTrackingService);

    krtMarketingTrackingService.$inject = ['$q', 'JobDetailsBus'];

    function krtMarketingTrackingService($q, JobDetailsBus) {

        var self = this;
        var SNOOZE_GROUP_ID = 1211587;
        var BK_GROUP_ID = 1178286;
        var PIZZA_HUT_GROUP_ID = 5245747;
        var CUMBERLAND_POINTE_PIZZA_HUT_ID = 5245681;
        var HAWKSMOOR_GROUP_ID = 1274345;
        var COLUMBIA_CITY_PIZZA_HUT_ID = 5245636;
        var AUBURN_PIZZA_HUT_ID  = 5245739;
        var EDEN_HOTEL_COLLECTION = 5615232;
        var SEA_CONTAINER = 3577122;
        var HAULFRYN = 6619217;
        var ONE_HUNDRED_SHOREDICH = 5319599;
        var PAPA_JOHNS_LOCATIONS = [5450010, 5451275, 5451300, 5451521, 5451546, 5451559, 5451877,
            5451904, 5451926, 5451933, 5451999, 5452039, 5452065, 5452099, 5452111, 5452142, 5452257,
            5452526, 5452396, 5452402, 5452537, 5452552, 5452578, 5452609, 5452431, 5452421, 5452669,
            5452410, 5455818, 5452346, 5452368, 5452338, 5452320, 5460710, 5452283, 5452270, 5461269,
            5461344, 5461535, 5461563, 5461939, 5461928, 5461894, 5461865, 5467207, 5474919, 5452153,
            5545260, 5452153, 5550664, 5550865, 5550875, 5551041, 5551230, 5633990, 5551370, 5551386,
            5551406, 5551416, 5551437, 5551447, 5551588, 5552902, 5552965, 5552982, 5553050, 5553076,
            5553084, 5553133, 5553242, 5553262, 5553273, 5553279, 5553291, 5553295, 5553324, 5553342,
            5553349, 5553373, 5553383, 5553409, 5553906, 5554126, 5553962, 5553923, 5552885, 5552865,
            5552844, 5552755, 5552689, 5552680, 5552667, 5553389, 5551810, 5551797, 5556483, 5556512,
            5556552, 5556558, 5556590, 5556608, 5556423, 5556417, 5556401, 5556391, 5556355, 5556341,
            5556306, 5556289, 5562044, 5562056, 5562087, 5562100, 5562122, 5562137, 5562149, 5562169,
            5562182, 5562212, 5562222, 5562230, 5562242, 5562248, 5566771, 5566884, 5566892, 5566920,
            5566928, 5566936, 5566949, 5566959, 5566970, 5566975, 5566982, 5567000, 5567010, 5567018,
            5567034, 5567300, 5567062, 5577968, 5577980, 5577995, 5578015, 5583972, 5583982, 5584018,
            5615605, 5615631, 5656173, 5553256, 5552926, 5551780, 5551017, 5685411, 5701557, 5701581,
            5701644, 5701673, 5727464, 5727467, 5750078, 5750089, 5750399, 5750434, 5750451, 5772856,
            5772874, 5772897, 5784587, 5784751, 5784759, 5784767, 5784772, 5790175, 5802556, 5825241];
        var CLICKIQ_BK_ID = "3ae4649f-9725-43d9-af21-c429ea48977f";
        var PREZZO = 1287529;
        const RED_CAT_GROUP_ID = 6345865;
        var MITCHELLS_AND_BUTLERS = 1006528;
        var KFC_GREAT_BRITAIN = 6152722;
        var LIBERATION_GROUP = 4718751;
        const YOUNGS_GROUP_ID = 13559663;
        const KFC_LOCATIONS = [
            4979602, 4979591, 4979575, 4979545, 4979532, 4957756, 4957313, 13615035,
            7191688, 6399769, 5028947, 5028931, 5028760, 5028752, 12556203, 9614370,
            7409901, 7409898, 5029075, 5029060, 5029051, 5029025, 8703593, 5029016,
            5029007, 5028999, 5028992, 5028982, 7191667, 5028971, 5028963, 5028956,
            5028938, 5028720, 9614404, 7191660, 5028922, 5028913, 5028900, 5028891,
            9319697, 7191681, 7191679, 5028745, 5028739, 6201108
        ]


        var viewed = {};
        var pendingStart = {};

        var USER_APPLICATION_ACTIONS = {
            VIEW: 'VIEW',
            START: 'START',
            COMPLETE: 'COMPLETE'
        };

        var __clickIq;
        var __fbq;


        var getAppCastPixelURL = function (groupId, ACTION) {
            if (ACTION === 'VIEW') {
                if (KFC_LOCATIONS.includes(groupId)) {
                    return "//click.appcast.io/pixels/harri1-24494.js?ent=417";
                } else if (groupId === EDEN_HOTEL_COLLECTION) {
                    return "//click.appcast.io/pixels/harri1-18504.js?ent=699";
                } else if (groupId === HAWKSMOOR_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri1-18537.js?ent=699";
                } else if (groupId === BK_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri1-18710.js?ent=699";
                } else if (groupId === SEA_CONTAINER) {
                    return "//click.appcast.io/pixels/harri1-18754.js?ent=699";
                } else if (groupId === HAULFRYN) {
                    return "//click.appcast.io/pixels/harri1-18443.js?ent=699";
                } else if (groupId === ONE_HUNDRED_SHOREDICH) {
                    return "//click.appcast.io/pixels/harri1-19001.js?ent=699";
                } else if (groupId === PREZZO) {
                    return "//click.appcast.io/pixels/harri1-19520.js?ent=699";
                } else if (groupId === MITCHELLS_AND_BUTLERS) {
                    return "//click.appcast.io/pixels/harri1-19486.js?ent=699";
                } else if (groupId === RED_CAT_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri1-24035.js?ent=235";
                }
            } else if (ACTION === 'START') {
                if (KFC_LOCATIONS.includes(groupId)) {
                    return "//click.appcast.io/pixels/harri2-24494.js?ent=417";
                } else if (groupId === EDEN_HOTEL_COLLECTION) {
                    return "//click.appcast.io/pixels/harri2-18504.js?ent=699";
                } else if (groupId === HAWKSMOOR_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri2-18537.js?ent=699";
                } else if (groupId === BK_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri2-18710.js?ent=699";
                } else if (groupId === SEA_CONTAINER) {
                    return "//click.appcast.io/pixels/harri2-18754.js?ent=699";
                } else if (groupId === HAULFRYN) {
                    return "//click.appcast.io/pixels/harri2-18443.js?ent=699";
                } else if (groupId === ONE_HUNDRED_SHOREDICH) {
                    return "//click.appcast.io/pixels/harri2-19001.js?ent=699";
                } else if (groupId === PREZZO) {
                    return "//click.appcast.io/pixels/harri2-19520.js?ent=699";
                } else if (groupId === MITCHELLS_AND_BUTLERS) {
                    return "//click.appcast.io/pixels/harri2-19486.js?ent=699";
                } else if (groupId === RED_CAT_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri2-24035.js?ent=235";
                }
            } else if (ACTION === 'COMPLETE') {
                if (KFC_LOCATIONS.includes(groupId)) {
                    return "//click.appcast.io/pixels/harri3-24494.js?ent=417";
                } else if (groupId === EDEN_HOTEL_COLLECTION) {
                    return "//click.appcast.io/pixels/harri3-18504.js?ent=699";
                } else if (groupId === HAWKSMOOR_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri3-18537.js?ent=699";
                } else if (groupId === BK_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri3-18710.js?ent=699";
                } else if (groupId === SEA_CONTAINER) {
                    return "//click.appcast.io/pixels/harri3-18754.js?ent=699";
                } else if (groupId === HAULFRYN) {
                    return "//click.appcast.io/pixels/harri3-18443.js?ent=699";
                } else if (groupId === ONE_HUNDRED_SHOREDICH) {
                    return "//click.appcast.io/pixels/harri3-19001.js?ent=699";
                } else if (groupId === PREZZO) {
                    return "//click.appcast.io/pixels/harri3-19520.js?ent=699";
                } else if (groupId === MITCHELLS_AND_BUTLERS) {
                    return "//click.appcast.io/pixels/harri3-19486.js?ent=699";
                } else if (groupId === RED_CAT_GROUP_ID) {
                    return "//click.appcast.io/pixels/harri3-24035.js?ent=235";
                }
            }

            if (groupId === SNOOZE_GROUP_ID) {
                return '//click.appcast.io/pixels/generic3-9273.js?ent=369&v=' + Date.now();
            }
        };

        const getJotrackTrackingScriptURL = function (groupId, ACTION) {
            if (groupId === YOUNGS_GROUP_ID) {
                if (ACTION === 'VIEW') {
                    return '//jotrack.s3.amazonaws.com/66oz/job-view.js';
                } else if (ACTION === 'START') {
                    return '//jotrack.s3.amazonaws.com/66oz/job-apply-start.js';
                } else if (ACTION === 'COMPLETE') {
                    return '//jotrack.s3.amazonaws.com/66oz/job-apply.js';
                }
            }
        };

        var getTrackingPixelURL = function (groupId) {
            if (groupId === SNOOZE_GROUP_ID) {
                return "//www.glassdoor.com/track/jobApply/complete.htm?partnerId=" + 632740 + "&cachebuster=" + Date.now();
            } else if (groupId === PIZZA_HUT_GROUP_ID) {
                return "//click.appcast.io/harri-9k/a17.png?ent=8&e=13805&t=" + Date.now();
            } else if (PAPA_JOHNS_LOCATIONS.indexOf(groupId) > -1) {
                return "//analytics.talentegy.com/img/ebed7163-4145-4f02-a143-070dfb23ef6c.png?tgtrk=1";
            } else if (groupId === HAWKSMOOR_GROUP_ID) {
                return "//www.facebook.com/tr?id=744021129795815&ev=PageView&noscript=1";
            } else if (groupId === KFC_GREAT_BRITAIN) {
                return "//www.facebook.com/tr?id=1536868646778370&ev=PageView&noscript=1";
            } else if (groupId === LIBERATION_GROUP) {
                return "//www.facebook.com/tr?id=3288544898072518&ev=PageView&noscript=1";
            }
        };

        var loadTrackingPixel = function (pixelURL) {
            var iTag = document.createElement("img");
            iTag.setAttribute("src", pixelURL);
            iTag.setAttribute("width", "1");
            iTag.setAttribute("height", "1");
            document.body.appendChild(iTag);
        };

        var loadBandoIQTrackingScript = function () {
            var headElm = document.getElementsByTagName('head')[0];
            var scriptElm = document.createElement('script');
            scriptElm.async = 1;
            scriptElm.src = "https://tracking.pandoiq.com/17523";
            headElm.appendChild(scriptElm);
        };

        var loadTalentegyTrackingScript = function () {
            var headElm = document.getElementsByTagName('head')[0];
            var scriptElm = document.createElement('script');
            scriptElm.async = 1;
            scriptElm.src = "https://analytics.talentegy.com/ebed7163-4145-4f02-a143-070dfb23ef6c.js";
            headElm.appendChild(scriptElm);
        };

        var loadClickIQTrackingScript = function () {

            var defer = $q.defer();

            if (__clickIq) {
                defer.resolve(__clickIq);
            }
            else {
                var headElm = document.getElementsByTagName('head')[0];
                var scriptElm = document.createElement('script');
                scriptElm.async = 1;
                scriptElm.src = "https://api.clickiq.co.uk/scripts/4.0/tracking.js";
                headElm.appendChild(scriptElm);

                var numberOfRetries = 0;

                var clickIqCheck = setInterval(function () {
                    numberOfRetries++;

                    if (window['__clickIq']) {
                        clearInterval(clickIqCheck);
                        __clickIq = window['__clickIq'];
                        defer.resolve(__clickIq);
                        delete window['__clickIq'];
                    }
                    else if (numberOfRetries > 25) {
                        clearInterval(clickIqCheck);
                        defer.reject();
                    }
                }, 300);
            }

            return defer.promise;
        };

        var loadFacebookPixelTracking = function () {
            var defer = $q.defer();

            if (__fbq) {
                defer.resolve(__fbq);
            } else {
                !function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;
                    n = f.fbq = function () {
                        n.callMethod ?
                            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                    };
                    if (!f._fbq) f._fbq = n;
                    n.push = n;
                    n.loaded = !0;
                    n.version = '2.0';
                    n.queue = [];
                    t = b.createElement(e);
                    t.async = !0;
                    t.src = v;
                    s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s)
                }(window, document, 'script',
                    'https://connect.facebook.net/en_US/fbevents.js');

                var numberOfRetries = 0;

                var fbqCheck = setInterval(function () {
                    numberOfRetries++;

                    if (window['fbq']) {
                        clearInterval(fbqCheck);
                        __fbq = window['fbq'];
                        defer.resolve(__fbq);
                    } else if (numberOfRetries > 25) {
                        clearInterval(fbqCheck);
                        defer.reject();
                    }
                }, 300);
            }
            return defer.promise;
        };

        var loadAppCastTrackingPixcel = function (url) {
            // numberOfInitCalls == 1, this means this is an entry page
            (function (h, o, t, j, a, r) {
                h.hj = h.hj || function () {
                    (h.hj.q = h.hj.q || []).push(arguments)
                };
                h._hjSettings = {hjid: 1444839, hjsv: 6};
                a = o.getElementsByTagName('head')[0];
                r = o.createElement('script');
                r.async = 1;
                r.src = t;
                a.appendChild(r);
            })(window, document, url);
        };

        const loadJotrackTrackingScript = function (url) {
            if (url) {
                var headElm = document.getElementsByTagName('head')[0];
                var scriptElm = document.createElement('script');
                scriptElm.type = 'text/javascript';
                scriptElm.id = 'jovscript';
                scriptElm.src = url;
                headElm.appendChild(scriptElm);
            }
        };

        self.trackView = function (jobId, pjt) {
            JobDetailsBus.getJob(jobId, pjt)
                .then(function (jobDetails) {
                    self.trackApplicationView(jobId, pjt);
                    viewed[jobId] = true;

                    if (pendingStart[jobId]) {
                        self.trackApplicationStart(jobId);
                        pendingStart[jobId] = false;
                    }
                });
        };

        self.trackApplicationView = function (jobId, pjt) {
            JobDetailsBus.getJob(jobId, pjt)
                .then(function (jobDetails) {
                    if (jobDetails.top_parent_brand && [EDEN_HOTEL_COLLECTION, BK_GROUP_ID, HAWKSMOOR_GROUP_ID, HAULFRYN, PREZZO, MITCHELLS_AND_BUTLERS, RED_CAT_GROUP_ID].indexOf(jobDetails.top_parent_brand.id) > -1) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.VIEW));
                    }

                    if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.id) > -1)) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.id, USER_APPLICATION_ACTIONS.VIEW));
                    }
                    if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.group_id)) > -1) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.group_id, USER_APPLICATION_ACTIONS.VIEW));
                    }
                    if (jobDetails.top_parent_brand && [LIBERATION_GROUP, KFC_GREAT_BRITAIN].indexOf(jobDetails.top_parent_brand.id) > -1) {
                        loadTrackingPixel(getTrackingPixelURL(jobDetails.top_parent_brand.id));
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === LIBERATION_GROUP) {
                        loadFacebookPixelTracking(LIBERATION_GROUP).then(function (__fbg) {
                            __fbg('init', '3288544898072518');
                            __fbg('track', 'PageView');
                        });
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === KFC_GREAT_BRITAIN) {
                        loadFacebookPixelTracking(KFC_GREAT_BRITAIN).then(function (__fbg) {
                            __fbg('init', '1536868646778370');
                            __fbg('track', 'PageView');
                        });
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === YOUNGS_GROUP_ID) {
                        loadJotrackTrackingScript(getJotrackTrackingScriptURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.VIEW));
                    }
                });
        };

        self.trackApplicationStart = function (jobId, pjt) {
            if (viewed[jobId]) {
                JobDetailsBus.getJob(jobId, pjt)
                    .then(function (jobDetails) {
                        if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === BK_GROUP_ID) {
                            loadClickIQTrackingScript()
                                .then(function (__clickIq) {
                                    __clickIq.Click('https://api.clickiq.co.uk/', CLICKIQ_BK_ID, jobId);
                                });
                        }

                        if (jobDetails.brand && jobDetails.brand.id && [CUMBERLAND_POINTE_PIZZA_HUT_ID, COLUMBIA_CITY_PIZZA_HUT_ID, AUBURN_PIZZA_HUT_ID].indexOf(jobDetails.brand.id) > -1) {
                            loadBandoIQTrackingScript();
                        }

                        if (jobDetails.top_parent_brand && [EDEN_HOTEL_COLLECTION, BK_GROUP_ID, HAWKSMOOR_GROUP_ID, HAULFRYN, PREZZO, MITCHELLS_AND_BUTLERS, RED_CAT_GROUP_ID].indexOf(jobDetails.top_parent_brand.id) > -1) {
                            loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.START));
                        }

                        if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.id) > -1)) {
                            loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.id, USER_APPLICATION_ACTIONS.START));
                        }
                        if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.group_id)) > -1) {
                            loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.group_id, USER_APPLICATION_ACTIONS.START));
                        }

                        if (jobDetails.top_parent_brand && [HAWKSMOOR_GROUP_ID, KFC_GREAT_BRITAIN, LIBERATION_GROUP].indexOf(jobDetails.top_parent_brand.id) > -1) {
                            loadTrackingPixel(getTrackingPixelURL(jobDetails.top_parent_brand.id));
                        }

                        if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === HAWKSMOOR_GROUP_ID) {
                            loadFacebookPixelTracking(HAWKSMOOR_GROUP_ID).then(function (__fbg) {
                                __fbg('init', '744021129795815');
                                __fbg('track', 'PageView');
                            });
                        }
                        if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === KFC_GREAT_BRITAIN) {
                            loadFacebookPixelTracking(KFC_GREAT_BRITAIN).then(function (__fbg) {
                                __fbg('init', '1536868646778370');
                                __fbg('track', 'PageView');
                            });
                        }
                        if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === LIBERATION_GROUP) {
                            loadFacebookPixelTracking(LIBERATION_GROUP).then(function (__fbg) {
                                __fbg('init', '3288544898072518');
                                __fbg('track', 'PageView');
                            });
                        }
                        if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === YOUNGS_GROUP_ID) {
                            loadJotrackTrackingScript(getJotrackTrackingScriptURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.START));
                        }

                    });

                viewed[jobId] = false;
            }
            else {
                pendingStart[jobId] = true;
            }
        };

        self.trackApplicationSent = function (jobId, pjt) {
            JobDetailsBus.getJob(jobId, pjt)
                .then(function (jobDetails) {
                    if (jobDetails.top_parent_brand && ([SNOOZE_GROUP_ID, HAWKSMOOR_GROUP_ID, KFC_GREAT_BRITAIN, PIZZA_HUT_GROUP_ID, LIBERATION_GROUP].concat(PAPA_JOHNS_LOCATIONS)).indexOf(jobDetails.top_parent_brand.id) > -1) {
                        loadTrackingPixel(getTrackingPixelURL(jobDetails.top_parent_brand.id));
                    }

                    if (jobDetails.brand && jobDetails.brand.id && [CUMBERLAND_POINTE_PIZZA_HUT_ID, COLUMBIA_CITY_PIZZA_HUT_ID, AUBURN_PIZZA_HUT_ID].indexOf(jobDetails.brand.id) > -1) {
                        loadBandoIQTrackingScript();
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === SNOOZE_GROUP_ID) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(SNOOZE_GROUP_ID));
                    }

                    if (jobDetails.top_parent_brand && [EDEN_HOTEL_COLLECTION, BK_GROUP_ID, HAWKSMOOR_GROUP_ID, HAULFRYN, PREZZO, MITCHELLS_AND_BUTLERS, RED_CAT_GROUP_ID].indexOf(jobDetails.top_parent_brand.id) > -1) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.COMPLETE));
                    }

                    if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.id) > -1)) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.id, USER_APPLICATION_ACTIONS.COMPLETE));
                    }
                    if (jobDetails.brand && ([ONE_HUNDRED_SHOREDICH, SEA_CONTAINER, ...KFC_LOCATIONS].indexOf(jobDetails.brand.group_id)) > -1) {
                        loadAppCastTrackingPixcel(getAppCastPixelURL(jobDetails.brand.group_id, USER_APPLICATION_ACTIONS.COMPLETE));
                    }

                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === HAWKSMOOR_GROUP_ID) {
                        loadFacebookPixelTracking(HAWKSMOOR_GROUP_ID).then(function (__fbg) {
                            __fbg('init', '744021129795815');
                            __fbg('track', 'PageView');
                        });
                    }

                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === KFC_GREAT_BRITAIN) {
                        loadFacebookPixelTracking(KFC_GREAT_BRITAIN).then(function (__fbg) {
                            __fbg('init', '1536868646778370');
                            __fbg('track', 'PageView');
                        });
                    }

                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === BK_GROUP_ID) {
                        loadClickIQTrackingScript()
                            .then(function (__clickIq) {
                                __clickIq.TrackApplication('https://api.clickiq.co.uk/', CLICKIQ_BK_ID, jobId);
                            });
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === LIBERATION_GROUP) {
                        loadFacebookPixelTracking(LIBERATION_GROUP).then(function (__fbg) {
                            __fbg('init', '3288544898072518');
                            __fbg('track', 'PageView');
                        });
                    }
                    if (jobDetails.top_parent_brand && jobDetails.top_parent_brand.id === YOUNGS_GROUP_ID) {
                        loadJotrackTrackingScript(getJotrackTrackingScriptURL(jobDetails.top_parent_brand.id, USER_APPLICATION_ACTIONS.COMPLETE));
                    }
                });
        };
    }
})();
